<template>
  <bm-overlay
    ref="customOverlay"
    :class="['sample', iconType]"
    pane="labelPane"
    @draw="draw"
  >
  </bm-overlay>
</template>

<script>
import BmOverlay from 'vue-baidu-map/components/overlays/Overlay'

export default {
  name: 'DashboardOverlay',
  props: ['markerData'],
  components: {
    BmOverlay
  },
  watch: {
    markerData: {
      handler() {
        this.$refs.customOverlay.reload()
      },
      deep: true
    }
  },
  computed: {
    iconType() {
      switch (this.markerData.Status) {
        case 'NORMAL':
          return 'mapOnline'
        case 'EXCESS':
          return 'mapAlert'
        case 'DOWN':
          return 'mapOffline'
        case 'OFF':
          return 'mapClosed'
        case 'ALARM':
          return 'mapPreAlert'
        default:
          return '@locale'
      }
    }
  },
  methods: {
    // 坐标转换函数：将高德坐标转换为百度坐标
    qqMapTransBMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng;
      let y = lat;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;
      // console.log('转换后lngs', lngs)
      // console.log('转换后lats', lats)
      return {
        lng: lngs,
        lat: lats
      }
    },
    draw({ el, BMap, map }) {
      const { LocaleLng, LocaleLat } = this.markerData
      // console.log('this.markerData',this.markerData)
      // console.log('转换前LocaleLng', LocaleLng)
      // console.log('转换前LocaleLat', LocaleLat)
      const mapTS =this.qqMapTransBMap(Number(LocaleLng), Number(LocaleLat))
      // console.log('转换后LocaleLng1', mapTS)
      // console.log('转换后LocaleLat1', mapTS)
      const pixel = map.pointToOverlayPixel(new BMap.Point(mapTS.lng, mapTS.lat))
      el.style.left = pixel.x - 14 + 'px'
      el.style.top = pixel.y - 20.5 + 'px'
    },
    getIcon(status) {
      switch (status) {
        case 'NORMAL':
          return '@/asset/img/mapOnline.png'
        case 'EXCESS':
          return '@/asset/img/mapAlert.png'
        case 'DOWN':
          return '@/asset/img/mapOffline.png'
        case 'OFF':
          return '@/asset/img/mapClosed.png'
        case 'ALARM':
          return '@/asset/img/mapPreAlert.png'
        default:
          return '@/asset/img/locale.png'
      }
    }
  }
}
</script>

<style scoped>
.sample {
  width: 28px;
  height: 41px;
  position: absolute;
}
.sample:hover {
  cursor: pointer;
}
.mapOnline {
  background: url('~@/asset/img/mapOnline.png') no-repeat;
}
.mapAlert {
  background: url('~@/asset/img/mapAlert.png') no-repeat;
}
.mapOffline {
  background: url('~@/asset/img/mapOffline.png') no-repeat;
}
.mapClosed {
  background: url('~@/asset/img/mapClosed.png') no-repeat;
}
.mapPreAlert {
  background: url('~@/asset/img/mapPreAlert.png') no-repeat;
}
.locale {
  background: url('~@/asset/img/locale.png') no-repeat;
}
</style>
